import { apiClient } from "../axios.config";
import type { Response } from "../dto/response/common.response";
import type {
  TournamentApplyListResponse,
  TournamentApplyListParams,
  TournamentDetailResponse,
  TournamentJoinedListResponse,
  TournamentCancelListParams,
  TournamentCancelListResponse,
  TournamentApplyDetailResponse,
} from "../dto/response/torunament.response";
import type { AlarmListResponse } from "../dto/response/setting.response";

const model = "/v1/setting";

/**
 * Setting Service API
 * @module SettingService
 * @description 마이페이지/설정 등 관련 API
 * @author DongGyun Yoo
 * @since 1.0.0
 */

export async function getSettingTournamentDetails(
  tournamentId: string | number,
): Promise<Response<TournamentDetailResponse>> {
  const { data } = await apiClient.get(
    `${model}/tournament/${tournamentId}/info`,
  );
  return data;
}

export async function getSettingTournamentApplyDetail(
  tournamentId: string | number,
  applyId: string | number,
): Promise<Response<TournamentApplyDetailResponse>> {
  const { data } = await apiClient.get(
    `${model}/tournament/${tournamentId}/apply/${applyId}/info`,
  );
  return data;
}

export async function tournamentApplyList(
  params: TournamentApplyListParams = {},
): Promise<Response<TournamentApplyListResponse>> {
  const { data } = await apiClient.get(`${model}/tournament-apply-list`, {
    params,
  });
  return data;
}

export async function tournamentJoinedList(): Promise<
  Response<TournamentJoinedListResponse>
> {
  const { data } = await apiClient.get(`${model}/tournament-joined-list`);
  return data;
}

export async function tournamentCancelList(
  params: TournamentCancelListParams = {},
): Promise<Response<TournamentCancelListResponse>> {
  const { data } = await apiClient.get(`${model}/tournament-cancel-list`, {
    params,
  });
  return data;
}

export async function paymentList() {
  const { data } = await apiClient.get(`${model}/payment-list`);
  return data;
}

/** 알림 목록 조회 */
export async function alarmList(): Promise<Response<AlarmListResponse>> {
  const { data } = await apiClient.get(`${model}/notification-list`);
  return data;
}

// 모두 읽음 처리 (isNew=false)
export async function readAllNotifications() {
  const { data } = await apiClient.put(`${model}/read-all-notification`);
  return data;
}

// 새 알림 존재 여부
export async function getNewAlarm() {
  const { data } = await apiClient.get(`${model}/has-new-notification`);
  return data;
}
